// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen8_comp__sbBP4"};